import React from 'react';
import { MapPin, Phone, Mail, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
    // WhatsApp contact function
    const handleWhatsappContact = () => {
        const phoneNumber = '923329754400';
        const message = encodeURIComponent('I am here for free consultation');
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8 relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wMiI+PHBhdGggZD0iTTM2IDM0djZoNnYtNmgtNnptNiA2djZoNnYtNmgtNnptLTEyIDBoNnY2aC02di02em0xMiAwaDZ2NmgtNnYtNnoiLz48cGF0aCBkPSJNMTIgMTJoNnY2aC02di02em02IDZoNnY2aC02di02em0wLTZoNnY2aC02di02em0xMiAwaDZ2NmgtNnYtNnptLTEyIDEyaDZ2NmgtNnYtNnptMTIgMGg2djZoLTZ2LTZ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-20"></div>
            
            {/* Footer Content */}
            <div className="container mx-auto px-4 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                    {/* About Section */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-indigo-300">About Us</h3>
                        <p className="text-gray-400 mb-6">
                            We never stop until we win. Providing excellent legal services with dedication and commitment.
                        </p>
                        <div className="flex space-x-4">
                            <button
                                type="button"
                                aria-label="Facebook"
                                onClick={() => window.open('https://facebook.com', '_blank')}
                                className="bg-gray-800 hover:bg-indigo-600 p-2 rounded-full text-white transition-colors duration-300"
                            >
                                <Facebook className="w-5 h-5" />
                            </button>
                            <button
                                type="button"
                                aria-label="Twitter"
                                onClick={() => window.open('https://twitter.com', '_blank')}
                                className="bg-gray-800 hover:bg-indigo-600 p-2 rounded-full text-white transition-colors duration-300"
                            >
                                <Twitter className="w-5 h-5" />
                            </button>
                            <button
                                type="button"
                                aria-label="LinkedIn"
                                onClick={() => window.open('https://linkedin.com', '_blank')}
                                className="bg-gray-800 hover:bg-indigo-600 p-2 rounded-full text-white transition-colors duration-300"
                            >
                                <Linkedin className="w-5 h-5" />
                            </button>
                            <button
                                type="button"
                                aria-label="Instagram"
                                onClick={() => window.open('https://instagram.com', '_blank')}
                                className="bg-gray-800 hover:bg-indigo-600 p-2 rounded-full text-white transition-colors duration-300"
                            >
                                <Instagram className="w-5 h-5" />
                            </button>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-indigo-300">Quick Links</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link to="/practice-areas" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Practice Areas
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Contact
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Blog
                                </Link>
                            </li>
                            <li>
                                <Link to="/faqs" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    FAQs
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Practice Areas */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-indigo-300">Practice Areas</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/services/criminal-law" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Family Law and Court Marriage
                                </Link>
                            </li>
                            <li>
                                <Link to="/services/family-law" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Criminal Law
                                </Link>
                            </li>
                            <li>
                                <Link to="/services/civil-law" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Civil Law
                                </Link>
                            </li>
                            <li>
                                <Link to="/services/business-law" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Business Law
                                </Link>
                            </li>
                            <li>
                                <Link to="/services/labor-law" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                                    Excise and Taxation
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-indigo-300">Contact Us</h3>
                        <div className="space-y-4">
                            <a href="https://maps.google.com/?q=office+no+330+Sher+Shah+Suri+block+2nd+floor+Dist+Courts+Rawalpindi" target="_blank" rel="noopener noreferrer" className="flex items-start group">
                                <div className="bg-gray-800 p-2 rounded-lg mr-3 group-hover:bg-indigo-600 transition-colors duration-300">
                                    <MapPin className="w-5 h-5 text-indigo-300 group-hover:text-white transition-colors duration-300" />
                                </div>
                                <div>
                                    <p className="text-gray-400 group-hover:text-white transition-colors duration-300">
                                        Office no 330, Sher Shah Suri block 2nd floor, Dist Courts Rawalpindi
                                    </p>
                                </div>
                            </a>
                            
                            <button onClick={handleWhatsappContact} className="flex items-start group w-full text-left">
                                <div className="bg-gray-800 p-2 rounded-lg mr-3 group-hover:bg-indigo-600 transition-colors duration-300">
                                    <Phone className="w-5 h-5 text-indigo-300 group-hover:text-white transition-colors duration-300" />
                                </div>
                                <div>
                                    <p className="text-gray-400 group-hover:text-white transition-colors duration-300">
                                        +92 332-9754400
                                    </p>
                                </div>
                            </button>
                            
                            <a href="mailto:chkhurram379@gmail.com" className="flex items-start group">
                                <div className="bg-gray-800 p-2 rounded-lg mr-3 group-hover:bg-indigo-600 transition-colors duration-300">
                                    <Mail className="w-5 h-5 text-indigo-300 group-hover:text-white transition-colors duration-300" />
                                </div>
                                <div>
                                    <p className="text-gray-400 group-hover:text-white transition-colors duration-300">
                                        chkhurram379@gmail.com
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-gray-800 mt-12 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-400 text-sm">
                            © {new Date().getFullYear()} Wisdoms Law. All rights reserved.
                        </p>
                        <p className="text-gray-500 text-sm mt-2 md:mt-0">
                            Designed with <span className="text-red-500">♥</span> by AIpreneur
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;